import React, { useState } from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/solid';
import api from '../api/client';

export default function Login({ onLogin }) {
  const [apiKey, setApiKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Save API key
      api.setApiKey(apiKey);
      
      // Test the API key by making a health check
      await api.healthCheck();
      
      // Success!
      onLogin();
    } catch (err) {
      setError('Invalid API key. Please check and try again.');
      api.clearApiKey();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-md w-full px-6">
        <div className="bg-gray-800 rounded-lg shadow-xl p-8 border border-gray-700">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <div className="bg-primary-600 p-4 rounded-full">
              <ShieldCheckIcon className="h-12 w-12 text-white" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-center mb-2 bg-gradient-to-r from-primary-400 to-primary-600 bg-clip-text text-transparent">
            CISO Advisor
          </h1>
          <p className="text-gray-400 text-center mb-8">
            AI-Powered Virtual CISO
          </p>

          {/* Login Form */}
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label htmlFor="apiKey" className="block text-sm font-medium text-gray-300 mb-2">
                API Key
              </label>
              <input
                id="apiKey"
                type="password"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-white placeholder-gray-400"
                placeholder="Enter your API key"
                required
              />
            </div>

            {error && (
              <div className="bg-danger-900/50 border border-danger-500 text-danger-200 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Authenticating...' : 'Sign In'}
            </button>
          </form>

          {/* Demo Instructions */}
          <div className="mt-6 p-4 bg-gray-700/50 rounded-lg border border-gray-600">
            <p className="text-sm text-gray-300 mb-2">
              <span className="font-semibold">Demo Access:</span>
            </p>
            <p className="text-xs text-gray-400">
              Use your generated API key or contact your administrator.
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-gray-500 text-sm mt-8">
          Quantitative Risk Assessment • Expected Annual Loss Calculations
        </p>
      </div>
    </div>
  );
}
